import type { CommunityDetail } from '@pba/react-network';
import { ContentWrapper, withErrorBoundary } from 'ui';
import { CommunitySideCards } from '../community-side-cards';
import { CommunityAssetsContent } from './community-assets-content';

type P = {
  community: CommunityDetail;
};

const CommunityAssets = ({ community }: P) => (
  <ContentWrapper aside={<CommunitySideCards community={community} />}>
    <CommunityAssetsContent community={community} />
  </ContentWrapper>
);

export default withErrorBoundary(CommunityAssets);
